<!--
    文件描述：页头、页尾
    创建人：殷俊
    创建时间：2022-07-11
-->
<template>
    <div>
        <header class="header">
            <img class='logo' src="@/assets/images/home/logo.png">
            <div class="navigationBar">
                <span :class="activeType == 1? 'active' : ''" @mouseover="hoverFirstPage" @mouseout="blurFirstPage" @click="goFirstPage">首页</span>
                <span :class="activeType == 2? 'active' : ''" @mouseover="hoverProduct" @click="clickProduct">解决方案</span>
                <span :class="activeType == 3? 'active' : ''" @mouseover="hoverAboutus" @mouseout="blurAboutus" @click="goAboutUs">关于我们</span>
<!--                <span @click="goStore">备件商城</span>-->
            </div>
        </header>
        <div class="main">
            <router-view/>
        </div>
        <footer class="footer">
            <div class="infoArea">
                <span class="left">
                    <div>电话： 13770761846</div>
                    <div>邮箱： chenxin@skywellcorp.com</div>
                    <div>地址： 江苏省南京市江宁区开沃创新中心C座15F</div>
                </span>
                <span class="right">
                    <span class='officialAccounts'>
                        <img src="@/assets/images/home/officialAccounts.png">
                        <p>公众号</p>
                    </span>
                    <span class='qrCode'>
                        <img src="@/assets/images/home/qrCode.png">
                        <p>名片</p>
                    </span>
                </span>
            </div>
            <div class="copyrightArea">
                <div class="copyright">版权©2024 沃行科技（南京）有限公司</div>
                <div class="provide">
                    <a href="https://beian.miit.gov.cn/" target="_blank"><span i18n="provide">备案号：苏ICP备2020050943号-4</span></a>
                </div>
            </div>
        </footer>

        <!-- 解决方案hover -->
        <div v-show="isShowHover" class="hoverPrducts" @mouseover="hoverProduct" @mouseout="blurProduct">
            <div class="blueWhale" @click="goBlueWhale">
                <img src="@/assets/images/home/hoverProducts/blueWhale.png">
                <p>观光接驳解决方案</p>
            </div>
            <div class="bus" @click="goBus">
                <img src="@/assets/images/home/hoverProducts/bus.png">
                <p>公交出行解决方案</p>
            </div>
            <div class="sweeper" @click="goSweeper">
                <img src="@/assets/images/home/hoverProducts/sweeper.png">
                <p>智慧清扫解决方案</p>
            </div>
            <div class="remoteDriving" @click="goRemoteDriving">
                <img src="@/assets/images/home/hoverProducts/remoteDriving.png">
                <p>远程驾驶解决方案</p>
            </div>
            <div class="materialFlow" @click="goMaterialFlow">
                <img src="@/assets/images/home/hoverProducts/materialFlow.png">
                <p>智慧物流解决方案</p>
            </div>
        </div>

        <!-- 咨询、返回顶部 -->
        <div class="consultAndTop">
<!--            <div class="consult" @click="contactUs">-->
<!--                <img src="@/assets/images/home/consult.png">-->
<!--                <p>咨询</p>-->
<!--            </div>-->
            <div class="top" @click="linkTop">
                <img src="@/assets/images/home/top.png">
                <p>顶部</p>
            </div>
        </div>

        <!-- 弹框 -->
        <Dialog v-show='dialog.data.show'></Dialog>
    </div>
</template>

<script>
import Dialog from '@/components/Dialog'
export default {
    name: 'home',
    components: {
        Dialog
    },
    data() {
        return {
            activeType: 1, // 首页 1; 解决方案 2
            dialog: this.$rv_dialog, // 弹出框
            isShowHover: false, // 是否显示解决方案hover
            isClickFirst: true // 是否第一次触发hover（用于防止移动端hover和click同时触发引发的bug）
        }
    },

    mounted() {
        this.initPage();
    },

    methods: {
        /**
         * 初始化页面
         * @param
         * @return
         */
        initPage () {
            this.clearDialog();

            let _this = this;
            // 横竖屏切换事件
            window.addEventListener('orientationchange', function() {
                _this.$router.go(0); // 刷新
            });
        },

        /**
         清空弹出框
         @param
         @return
         */
        clearDialog() {
            this.dialog.show = false
        },

        /**
         * 首页hover
         * @param
         * @return
         */
        hoverFirstPage() {
            this.activeType = 1;
        },

        /**
         * 首页blur
         * @param
         * @return
         */
        blurFirstPage() {
            this.activeType = 0;
        },

        /**
         * 解决方案hover
         * @param
         * @return
         */
        hoverProduct() {
            this.activeType = 2;
            this.isShowHover = true;
        },

        /**
         * 解决方案click
         * @param
         * @return
         */
        clickProduct() {
            // 是否第一次点击
            if(this.isClickFirst) {
                this.isClickFirst = false
            }else {
                if(this.isShowHover) {
                    this.isShowHover = false;
                }else {
                    this.isShowHover = true;
                }
            }
        },

        /**
         * 解决方案blur
         * @param
         * @return
         */
        blurProduct() {
            this.activeType = 0;
            this.isShowHover = false;
        },

        /**
         * 关于我们hover
         * @param
         * @return
         */
        hoverAboutus() {
            this.activeType = 3;
        },

        /**
         * 关于我们blur
         * @param
         * @return
         */
        blurAboutus() {
            this.activeType = 0;
        },

        /**
         跳转--联系客服
         @param
         @return
         */
        // contactUs() {
        //     window.open('https://kefu.ywkefu.com/chat/api/chatGroup/h5/600');
        // },

        /**
         * 滚动到--顶部
         * @param
         * @return
         */
        linkTop() {
            window.scrollTo(0, 0)
        },

        /**
         * 跳转--首页
         * @param
         * @return
         */
        goFirstPage() {
            // 初始化第一次点击标志
            this.isClickFirst = true;
            this.isShowHover = false;
            this.$router.push({path: '/firstPage'})
        },

        /**
         * 跳转--备件商城
         * @param
         * @return
         */
        goStore() {
            // 初始化第一次点击标志
            this.isClickFirst = true;
            this.isShowHover = false;
            window.open('/#/store/firstPage', '_blank');
        },

        /**
         * 跳转--观光接驳解决方案
         * @param
         * @return
         */
        goBlueWhale() {
            this.isShowHover = false;
            this.$router.push({path: '/blueWhale'})
        },

        /**
         * 跳转--公交出行解决方案
         * @param
         * @return
         */
        goBus() {
            this.isShowHover = false;
            this.$router.push({path: '/bus'})
        },

        /**
         * 跳转--智慧清扫解决方案
         * @param
         * @return
         */
        goSweeper() {
            this.isShowHover = false;
            this.$router.push({path: '/sweeper'})
        },

        /**
         * 跳转--远程驾驶解决方案
         * @param
         * @return
         */
        goRemoteDriving() {
            this.isShowHover = false;
            this.$router.push({path: '/remoteDriving'})
        },

        /**
         * 跳转--智慧物流解决方案
         * @param
         * @return
         */
        goMaterialFlow() {
            this.isShowHover = false;
            this.$router.push({path: '/materialFlow'})
        },

        /**
         * 跳转--关于我们
         * @param
         * @return
         */
        goAboutUs() {
            // 初始化第一次点击标志
            this.isClickFirst = true;
            this.isShowHover = false;
            this.$router.push({path: '/aboutUs'})
        }
    }
}
</script>

<style lang="less" scoped>
.header {
    position: relative;
    height: 0.8rem;
    >.logo {
        position: absolute;
        top: 0.2rem;
        left: 3.60rem;
        width: 3.45rem;
        height: 0.45rem;
    }
    >.navigationBar {
        position: absolute;
        top: 0.25rem;
        right: 20%;
        width: 4rem;
        >span {
            position: absolute;
            margin-right: 0.42rem;
            padding: 0.07rem 0.24rem;
            cursor: pointer;
        }
        >span:nth-child(1) {
            left: 0;
        }
        >span:nth-child(2) {
            left: 1rem;
        }
        >span:nth-child(3) {
            left: 2.2rem;
        }
        >.active {
            background: #337EBB;
            border-radius: 0.15rem;
            color: #FFFFFF;
        }
    }
}

.footer {
    position: relative;
    height: 4.00rem;
    background: url(../../assets/images/home/footerBg.png) no-repeat center center;
    background-size: 100% 100%;
    color: #ffffff;
    >.infoArea {
        position: absolute;
        top: 2.09rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 12.00rem;
        >.left {
            >div {
                margin-bottom: 0.10rem;
            }
        }
        >.right {
            position: absolute;
            top: -0.65rem;
            right: 0;
            text-align: center;
            >.officialAccounts {
                float: left;
                margin-right: 0.58rem;
                >img {
                    width: 1.29rem;
                    height: 1.29rem;
                }
                >p {
                    font-size: 0.16rem;
                    letter-spacing: 0.02em;
                    line-height: 160%;
                    color: #FFFFFF;
                }
            }
            >.qrCode {
                float: right;
                >img {
                    width: 1.29rem;
                    height: 1.29rem;
                }
                >p {
                    font-size: 0.16rem;
                    letter-spacing: 0.02em;
                    line-height: 160%;
                    color: #FFFFFF;
                }
            }
        }
    }
    .copyrightArea {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0.30rem;
        margin: 0 auto;
        width: 12.00rem;
        text-align: center;
        >.copyright {
            display: inline-block;
        }
        >.provide {
            margin-left: 1rem;
            display: inline-block;
            >a {
                color: inherit;
                text-decoration: none;
            }
        }
    }
}

.hoverPrducts {
    position: absolute;
    top: 0.8rem;
    width: 100%;
    height: 3.04rem;
    background-color: white;
    z-index: 1000;
    >div {
        display: inline-block;
        text-align: center;
    }
    >div:hover {
        color: #337EBB;
        cursor: pointer;
    }
    >.blueWhale {
        position: absolute;
        left: 1.38rem;
        top: 0.72rem;
        >img {
            width: 2.23rem;
            height: 1.26rem;
        }
        >p {
            margin-top: 0.1rem;
        }
    }
    >.bus {
        position: absolute;
        left: 4.91rem;
        top: 0.75rem;
        width: 2.75rem;
        height: 1.11rem;
        >img {
            width: 2.75rem;
            height: 1.11rem;
        }
        >p {
            margin-top: 0.2rem;
        }
    }
    >.sweeper {
        position: absolute;
        left: 9.11rem;
        top: 0.5rem;
        >img {
            width: 2.05rem;
            height: 1.50rem;
        }
        >p {
            margin-top: 0.04rem;
        }
    }
    >.remoteDriving {
        position: absolute;
        right: 5.13rem;
        top: 0.5rem;
        >img {
            width: 1.565rem;
            height: 1.485rem;
        }
        >p {
            margin-top: 0.05rem;
        }
    }
    >.materialFlow {
        position: absolute;
        right: 1.51rem;
        top: 0.32rem;
        >img {
            width: 2.26rem;
            height: 1.48rem;
        }
        >p {
            margin-top: 0.17rem;
        }
    }
}

.consultAndTop {
    position: fixed;
    bottom: 2rem;
    right: 0.15rem;
    width: 0.6rem;
    //height: 1.22rem;
    //border: 0.01rem solid #a1a1a1;
    text-align: center;
    z-index: 10000;
    >.consult {
        height: 0.6rem;
        background-color: #337ebb;
        color: #fff;
        cursor: pointer;
        >img {
            margin-top: 0.05rem;
            width: 0.28rem;
            height: 0.28rem;
        }
        >p {
            margin-top: -0.05rem;
        }
    }
    >.top {
        height: 0.6rem;
        background-color: #fff;
        cursor: pointer;
        >img {
            margin-top: 0.10rem;
            width: 0.19rem;
            height: 0.16rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/sys/home.vue